<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        Bank Reconciliation List
      </span>
      <a-button-group ghost>
        <!-- <a-button hidden @click="handleReload" icon="reload">
          <span>Reload</span>
        </a-button> -->
        <!-- <a-button icon="plus" type="primary" @click="handleCreate">
          <span>Create</span>
        </a-button> -->
      </a-button-group>
    </div>
    <div class="wrapper-body">
      <a-card>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 20 }">
          <a-select
            placeholder="All Bank Account"
            v-model="typebankaccount"
            :onchange="moreSearch"
            class="width-full"
            initialValue="all"
            :filterOption="filterOption"
            showSearch
            allowClear
          >
            <a-select-option
              v-for="item in bank"
              :key="item.value"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <a-month-picker
              placeholder="Select Periode Date"
              :format="'MM-YYYY'"
              picker="month"
              :allowClear="false"
              v-model="periodereconsile"
              @change="handlechangeperiod"
            />
          </a-col>
        </a-row>
        <!-- <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
            <a-input-search v-model="search" :onchange="moreSearch" placeholder="Quick Search" />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button
              :class="getScreen ? 'margin-top' : ''"
              block
              :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
              @click="handleshowMore"
              >{{
                advancedsearch == "display:none" ? "More" : "Less"
              }}</a-button
            >
          </a-col>
        </a-row>
        <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Transaction Date</label>
              <a-range-picker
                :placeholder="['Start Date', 'End Date']"
                v-model="transactionDt"
                :format="getDefaultDateFormat"
                allowClear
              />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
            <div class="m-form-item-wrapper">
              <label>Bank Account</label>
              <a-select
                placeholder="All Bank Account"
                v-model="typebankaccount"
                class="width-full"
                initialValue="all"
                :filterOption="filterOption"
                showSearch
                allowClear
              >
                <a-select-option
                  v-for="item in bank"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.text }}</a-select-option
                >
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div class="m-form-item-wrapper">
              <label>Status</label>
              <a-select
                showSearch
                v-model="typestatus"
                placeholder="All Status"
                class="width-full"
                initialValue="all"
                allowClear
                :filterOption="filterOption"
              >
                <a-select-option value="N">Non Canceled</a-select-option>
                <a-select-option value="C">Canceled</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div
              class="m-form-item-wrapper"
            >
              <label>Type</label>
              <a-select
                showSearch
                v-model="type_debcred"
                placeholder="All Type"
                class="width-full"
                initialValue="undefined"
                allowClear
                :filterOption="filterOption"
              >
                <a-select-option value="Debit">Debit</a-select-option>
                <a-select-option value="Credit">Credit</a-select-option>
              </a-select>
            </div>
          </a-col>
        </a-row> -->
      </a-card>
      <div class="bordered">
        <a-config-provider :locale="getLocalConfigProvider()">
          <a-table
            rowKey="bank_account_id"
            key="dtreconcile"
            size="small"
            bordered
            :scroll="{ x: 1150 }"
            :columns="columns"
            :dataSource="tempdatareconcile"
            :loading="loading"
          >
            <template slot="bank" slot-scope="data">
              <div class="m-display-flex nowrap space-between" style="justify-content: left;align-items: center;">
                <img :src="urllogo+'assets/bank/'+data.logo_bank" class="image_logo"
                v-bind:onerror="'this.src='+urllogonotfound"
                >
                  <!-- <a-avatar size="large" shape="square"
                  :src="urllogo+'assets/bank/'+data.logo_bank"
                  >
                    <template #icon><UserOutlined /></template>
                  </a-avatar> -->
                  <span>{{ data.nama_bank }} ({{data.bank_account_id}})</span>
              </div>
            </template>
            <template slot="account" slot-scope="data">
              {{data.kode_rekening}}
            </template>
            <template slot="balance" slot-scope="data">
              <CurrencyJustified
                :currencyValue="data.currency"
                :valueNumber="data.balance"
              />
            </template>
            <template slot="act" slot-scope="text, data">
              <a-button-group>
                <a-button
                  type="primary"
                  @click="handleViewFile(data)"
                  icon="eye"
                  > View Detail
                  </a-button>
              </a-button-group>
            </template>
          </a-table>
        </a-config-provider>
      </div>
    </div>

    <a-modal
      v-if="modalCreate"
      v-model="modalCreate"
      title="Create Bank Reconciliation"
      :width="500"
      centered
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleClose"
      okText="OK"
      cancelText="Cancel"
    >
      <a-form-model ref="reconform" :model="form" :rules="rules">
        <a-form-model-item
          ref="date"
          label="Date"
          prop="date"
        >
          <a-date-picker 
            v-model="form.date"
            format="DD-MM-YYYY"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="bank"
          label="Bank Account"
          prop="bank"
        >
          <a-select
            placeholder="All Bank Account"
            v-model="form.bank"
            class="width-full"
            :filterOption="filterOption"
            showSearch
            allowClear
            @blur="
              () => {
                $refs.bank.onFieldBlur();
              }
            "
          >
            <a-select-option
              v-for="item in bank"
              :key="item.value"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="description"
          label="Description"
          prop="description"
        >
          <a-input
            v-model="form.description"
            @blur="
              () => {
                $refs.description.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
        ref="type"
        label="Type Transaction"
        prop="type"
      >
        <a-radio-group
            buttonStyle="solid"
            v-model="form.type"
          >
            <a-radio-button value="D">Debit</a-radio-button>
            <a-radio-button value="K">Credit</a-radio-button>
        </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          ref="valu"
          label="Value (IDR)"
          prop="valu"
        >
          <a-input-number
            :min="0"
            class="m-width-full m-text-align right"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-model="form.valu"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item
          ref="note"
          label="Note"
          prop="note"
        >
          <a-textarea
            v-model="form.note"
            @blur="
              () => {
                $refs.note.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="file" prop="file" label="File Attachment">
          <a-upload
            v-model="form.file"
            :showUploadList="true"
            :beforeUpload="beforeUpload"
            :remove="handleRemoveList"
          >
            <a-button
              ref="btndocument"
              icon="upload"
              >Select File
            </a-button>
          </a-upload>
        </a-form-model-item>
        
      <template slot="footer">
        <a-button key="back" @click="handleClose"> Cancel </a-button>
        <!-- <a-button @click="handleClose()">Tutup</a-button> -->
        
      </template>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "reconcile-index",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  data() {
    const columns = [
        {
          title: "Bank",
          key: "bank",
          scopedSlots: { customRender: "bank" },
          width: 150,
          align: "left",
        },
        {
          title: "Account",
          key: "account",
          scopedSlots: { customRender: "account" },
          width: 120,
        },
        {
          title: "Balance",
          key: "balance",
          width: 100,
          scopedSlots: { customRender: "balance" },
        },
        {
          title: "Periode",
          key: "periode",
          width: 80,
          dataIndex: "periode",
          align: "right",
        },
        {
          title: "Action",
          key: "act",
          scopedSlots: { customRender: "act" },
          width: 80,
          align: "center",
        },
      ];
    return {
      columns,
      tempdatareconcile:[],
      datareconcile:[],
      loading: false,
      search: undefined,
      typebankaccount: undefined,
      transactionDt: [],
      advancedsearch: "display:none",
      typestatus: undefined,
      supplier_nm: undefined,
      type_debcred: undefined,
      bank:[],
      modalCreate: false,
      form: {
        date : moment(),
        bank : null,
        description: null,
        type: "D",
        valu: 0,
        note: "",
        file:[]
      },
      rules:{
        date: [
          {
            required: true,
            message: "Please input Date",
            trigger: "change",
          },
        ],
        bank: [
          {
            required: true,
            message: "Please input Bank Account",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Please input Description",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "Please input Type Transaction",
            trigger: "blur",
          },
        ],
        valu: [
          {
            required: true,
            message: "Please input Value",
            trigger: "blur",
          },
        ],
        note: [
          {
            required: true,
            message: "Please input Note",
            trigger: "blur",
          },
        ],
        file: [
          {
            required: true,
            message: "Please input File Attachment",
            trigger: "change",
          },
        ],
      },
      urllogo: this.$serviceUrl,
      urllogonotfound: '"'+this.$serviceUrl+'assets/bank/not-found.png"',
      periodereconsile : moment().subtract(1, 'month'),
    };
  },
  mounted() {
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    moreSearch: function () {
      let tempfilter = this.datareconcile;
      if (this.datareconcile.length > 0) {
        if (this.search) {
          tempfilter = tempfilter.filter(
            (obj) =>
              (obj.allstring &&
                obj.allstring
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) 
          );
        }

        if (this.typebankaccount) {
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.bank_account_id && obj.bank_account_id == this.typebankaccount
          );
        }

        if (this.transactionDt && this.transactionDt.length > 0) {
          let startDt = moment(this.transactionDt[0]).format("DD-MM-YYYY");
          let endDt = moment(this.transactionDt[1]).format("DD-MM-YYYY");
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.date &&
              moment(moment(obj.date, "DD-MM-YYYY").toDate()).format("DD-MM-YYYY") >= startDt &&
              moment(moment(obj.date, "DD-MM-YYYY").toDate()).format("DD-MM-YYYY") <= endDt
          );

        }

        if (this.typestatus) {
          if(this.typestatus=="C"){
            tempfilter = tempfilter.filter(
              (obj) =>
                (obj.cancel_sts &&
                  obj.cancel_sts
                    .toLowerCase()
                    .indexOf("Canceled by".toLowerCase()) >= 0) 
            );
          }else{
            tempfilter = tempfilter.filter(
            (obj) => obj.cancel_sts == null);
          }
        }

        if (this.type_debcred) {
          if (this.type_debcred) {
            tempfilter = tempfilter.filter(
              (obj) => obj.type && obj.type == this.type_debcred
            );
          }
        }
      }
      
      if (
        (!this.search || this.search=="") &&
        (!this.transactionDt ||this.transactionDt.length==0) &&
        !this.typebankaccount &&
        !this.typestatus &&
        !this.type_debcred
      ) {
        tempfilter = this.datareconcile;
      }

      this.tempdatareconcile = tempfilter;
      return true;
    },
    isFc(){
      return this.$route.path.includes('/financialControl')?true:false
    }
  },
  created() {
    this.handleReload();
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.typebankaccount = undefined;
      this.typestatus = undefined;
      this.type_debcred = undefined;
    },
    resetForm(){
      this.form = {
        date : moment(),
        bank : null,
        description: null,
        type: "D",
        valu: 0,
        note: "",
        file:[]
      };
    },
    intoList(type, value) {
      if (type == "release") {
        this.release = value;
      } else if (type == "queue") {
        this.queue = value;
      } else {
        this.needProcess = value;
      }
    },
    handleReload() {
      this.loading = true;
      this.$store.dispatch("getbanklist", { auth: this.getAuth }).then((res) => {
        this.bank = res.data.bank_account;
      });
      this.$store.dispatch("getDataReconcile", { auth: this.getAuth, periode : moment(this.periodereconsile).format("YYYY-MM") })
      .then((res) => {
        this.datareconcile = res.data;
        this.datareconcile.forEach((element, index) => {
          this.datareconcile[index].allstring = (element.no_transaction ? element.no_transaction : "")
            + (element.date ? element.date : "")
            + (element.bank_account ? element.bank_account : "")
            + (element.description ? element.description : "")
            + (element.note ? element.note : "")
            + (element.value ? this.formatRupiah(element.value) : "")
            + (element.type ? element.type : "")
            + (element.create_by ? element.create_by : "")
            + (element.cancel_sts ? element.cancel_sts : "")
        });
        
        this.tempdatareconcile = this.datareconcile;
        this.loading = false;
      })
      .catch((err) => {
        let responses = Object.assign({}, err.response.data);
        this.displayMessageValue("error", responses.message);
      });
      this.resetSearch();
    },
    handleCreate() {
      // this.$router.push({
      //   name: "reconciliation-detil",
      //   params: { id: "x", type: "x" },
      // });
      this.modalCreate = true;
    },
    handleCancel(item){
      const that = this;
      this.$confirm({
        title: "Are you sure to cancel this data?",
        content: "",
        okText:"Yes",
        cancelText:"No",
        onOk() {
          let params = new FormData();
          params.append("tlc",that.getAuth.username);
          params.append("bank_rekonsiliasi_id",item.bank_rekonsiliasi_id);
          that.loading = true;
          that.$store.dispatch("cancelReconcile", { auth: that.getAuth, params })
          .then((res) => {
            if(res.data.status==true){
              that.displayMessageValue("success-other", res.data.message);
              that.handleReload();
            }else{
              that.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            that.loading = false;
          })
          .catch(err => {
            console.log(err);
              that.loading = false;
          });
        },
          onCancel() {},
        });
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    handleViewFile(item) {
      // window.open(this.$serviceUrl + item.file_url);
      this.$router.push({
        name: this.isFc?"reconciliation-detilFin":"reconciliation-detil",
        params: { id: item.bank_account_id, periode_reconsile: item.periode_bulan+'-01'},
      });
    },
    handleRemoveList() {
      this.form.file = undefined;
    },
    beforeUpload(file) {
      this.form.file = [file];
      return false;
    },
    handleClose(){
      this.resetForm();
      this.$refs.file=null;
      this.modalCreate = false;
    },
    handleOk(){
      this.$refs.reconform.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
      
        let formData = new FormData();
        formData.append("tlc",this.getAuth.username);
        formData.append("date",moment(this.form.date).format('YYYY-MM-DD'));
        formData.append("bank_account", this.form.bank);
        formData.append("type_transaction", this.form.type);
        formData.append("description", this.form.description);
        formData.append("value", this.form.valu);
        formData.append("note", this.form.note);
        formData.append("upload_file", this.form.file[0]);
        
        this.loading = true;
        this.$store.dispatch("createReconcile", { auth: this.getAuth, 
        params: formData })
        .then((res) => {
          if(res.data.status==true){
            this.displayMessageValue("success-other", res.data.message);
            this.resetForm();
            this.$nextTick(() => {
              this.form.file = undefined;
            });
            this.handleReload();
          }else{
            this.displayMessageValue(
              "error-other",
              res.data.message
            );
          }
          this.loading = false;

        })
        .catch(err => {
          console.log("err",err);
            this.loading = false;
        });
        this.modalCreate = false;
      });
    },
    handlechangeperiod(){
      this.handleReload();
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead > tr > th {
  text-align: center;
}

.image_logo {
  max-width: 30%;
  max-height: 100%;
  margin-right: 10px;
  object-fit: scale-down;
}
</style>
